export default "__VITE_ASSET__CjDpP90p__"